module.exports = __webpack_public_path__ + "img/CASHOUT-USER-PPOB.d1181acc.jpg";